import { useEffect, useState } from 'react';
import { Form, Input, Select, DatePicker, Switch, Button, Card, Row, Col, message, Space, Alert } from 'antd';
import { SaveOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import AdminSidebar from '../Components/Sidebar';
import TextArea from 'antd/es/input/TextArea';
import { createOrUpdateSettings, getSettings } from '../redux/slices/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';

function PrivacyPolicy() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const dispatch = useDispatch();

    const onReset = () => {
        form.resetFields();
        message.info('Form has been reset');
    };

    const { settings } = useSelector((state) => state?.settings)

    useEffect(() => {
        dispatch(getSettings())
    }, [dispatch])

    useEffect(() => {
        if (settings?.data) {
            form.setFieldsValue({
                privacy_policy : settings?.data?.privacy_policy
            })
        }
    }, [settings, form])

    const onSubmit = async (values) => {
        setLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(createOrUpdateSettings({
                privacy_policy : values.privacy_policy,
                type : "Privacy Policy"
            }));

            if (createOrUpdateSettings.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Privacy Policy updated successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                setAlertMessage(resultAction?.payload?.error || 'Failed to update privacy policy');
                setAlertType('alert m-3 alert-danger');
            }

        } catch (error) {
            setAlertMessage('Failed to create sub services');
            setAlertType('alert m-3 alert-danger');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                title="Privacy Policy"
                style={{ marginBottom: 24 }}
            >
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                    initialValues={{
                        status: 'active',
                        notifications: true,
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Privacy Policy"
                        name="privacy_policy"
                    >
                        <TextArea
                            rows={4}
                            placeholder="Enter Privacy Policy"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Space>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                                loading={loading}
                                size="large"
                            >
                                Submit
                            </Button>
                            <Button
                                htmlType="button"
                                onClick={onReset}
                                size="large"
                            >
                                Reset
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
            } />
            
        </>
    );
}

export default PrivacyPolicy;